<div class="assignees">
  @for (assignee of assignees; track assignee; let i = $index) {
    @if (i < maxDisplay) {
      <user-profile-image-component
        [user]="assignee"
        [size]="size"
        [textOnly]="true"
      ></user-profile-image-component>
    }
  }
  @if (assignees.length - maxDisplay > 0) {
    <user-profile-image-component
      [user]="{ firstName: '+', lastName: assignees.length - maxDisplay }"
      [size]="size"
      [textOnly]="true"
    ></user-profile-image-component>
  }
</div>
